import React, { useState, useEffect } from 'react';
import { Box, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Chart from './Chart';
import ZoomableDiagram from './ZoomableDiagram';
import { SENSOR_LABELS } from '../config/sensorLabels/endPier4';

/** Assets live in public/End Pier 4/ — edit filenames in getTabImageMap() below */
const endPier4Asset = (fileName) =>
  `/${encodeURIComponent('End Pier 4')}/${encodeURIComponent(fileName)}`;

/** Tab id (URL ?tab=) → image filename in public/End Pier 4/ */
export const END_PIER_4_TAB_IMAGE_MAP = {
  Navigation: 'nav.png',
  // 'Left Edge': 'Left Edge.png',
  // 'Left Center': 'Left Center.png',
  // 'Right Center': 'Right Center.png',
  // 'Right Edge': 'Right Edge.png',
};

export const END_PIER_4_TAB_OPTIONS = [
  { value: 'Navigation', label: 'Navigation' },
  // { value: 'Left Edge', label: 'Left Edge' },
  // { value: 'Left Center', label: 'Left Center' },
  // { value: 'Right Center', label: 'Right Center' },
  // { value: 'Right Edge', label: 'Right Edge' },
];

const ALLOWED_TABS = Object.keys(END_PIER_4_TAB_IMAGE_MAP);

const EndPier4Board = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState('Navigation');
  const [structureImage, setStructureImage] = useState(() => endPier4Asset('nav.png'));

  useEffect(() => {
    const imageFileName = END_PIER_4_TAB_IMAGE_MAP[selectedTab];
    if (imageFileName) {
      const img = new Image();
      img.onerror = () => {
        setStructureImage('/new_bridge_rendering.png');
      };
      img.onload = () => {
        setStructureImage(endPier4Asset(imageFileName));
      };
      img.src = endPier4Asset(imageFileName);
    } else {
      setStructureImage('/new_bridge_rendering.png');
    }
  }, [selectedTab]);

  useEffect(() => {
    const tabFromUrl = new URLSearchParams(location.search).get('tab') || 'Navigation';
    setSelectedTab(ALLOWED_TABS.includes(tabFromUrl) ? tabFromUrl : 'Navigation');
  }, [location.search]);

  const panelHeight = 'calc(100vh - 235px)';

  return (
    <Box sx={{
      p: 0,
      pt: 0,
      width: '100%',
      maxWidth: 'none',
      mx: 0,
      minWidth: 0,
      bgcolor: 'white',
    }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1.25,
          alignItems: 'stretch',
          mt: 0,
          mb: 0,
          px: 0,
          flexWrap: 'nowrap',
          height: panelHeight,
        }}
      >
        <ZoomableDiagram
          src={structureImage}
          alt={`End Pier 4 - ${selectedTab}`}
          onImageError={(e) => {
            e.target.src = '/new_bridge_rendering.png';
          }}
        />

        <Paper elevation={2} sx={{ p: 1.5, flex: 1, minWidth: 0, width: '100%', height: '100%', overflow: 'auto' }}>
          <Chart compact pier={4} hideTabsAndImage sensorLabels={SENSOR_LABELS} />
        </Paper>
      </Box>
    </Box>
  );
};

export default EndPier4Board;
